const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20style%20illustration%20of%20a%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20warm%20sunset%20lighting%2C%20soft%20coral%20and%20amber%20tones%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=400&height=280&seq=card-01&orientation=landscape',
    title: '奇幻漫画入门指南',
    tag: '编辑推荐',
    desc: '从经典到新锐，为你梳理奇幻题材漫画的必读清单，打开异世界的大门从这里开始。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20romantic%20manga%20style%20scene%20with%20two%20characters%20walking%20on%20a%20sunset%20beach%2C%20soft%20golden%20light%2C%20tender%20atmosphere%2C%20minimal%20background%2C%20emotional%20storytelling%20composition&width=400&height=280&seq=card-02&orientation=landscape',
    title: '高甜恋爱漫画精选',
    tag: '专题推荐',
    desc: '糖分超标的恋爱漫画合集，从校园到职场，每一部都能让你嘴角上扬看到停不下来。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20style%20action%20scene%20with%20a%20warrior%20leaping%20through%20the%20air%20with%20energy%20effects%2C%20warm%20coral%20dynamic%20lines%2C%20powerful%20composition%2C%20clean%20background&width=400&height=280&seq=card-03&orientation=landscape',
    title: '热血战斗漫画TOP10',
    tag: '榜单推荐',
    desc: '燃到爆炸的战斗漫画排行，从经典名作到当季新番，点燃你的热血之魂。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20manga%20style%20scene%20with%20silhouette%20figures%20and%20dramatic%20shadow%20play%2C%20atmospheric%20warm%20lighting%2C%20tense%20composition%2C%20clean%20minimal%20background%2C%20suspenseful&width=400&height=280&seq=card-04&orientation=landscape',
    title: '悬疑推理漫画合集',
    tag: '分类推荐',
    desc: '烧脑反转停不下来，五部高智商悬疑推理漫画推荐，每一部都让你猜不到结局。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20serene%20manga%20style%20classroom%20scene%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20peaceful%20slice%20of%20life%20aesthetic%2C%20soft%20cream%20tones%2C%20nostalgic%20atmosphere&width=400&height=280&seq=card-05&orientation=landscape',
    title: '治愈系日常漫画',
    tag: '主题推荐',
    desc: '温暖人心的日常系漫画，没有复杂剧情，只有简单美好的生活片段治愈你的每一天。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20with%20ancient%20Chinese%20architecture%20and%20flowing%20silk%2C%20elegant%20warm%20amber%20tones%2C%20traditional%20aesthetic%2C%20refined%20composition%2C%20cultural%20atmosphere&width=400&height=280&seq=card-06&orientation=landscape',
    title: '国漫崛起力作推荐',
    tag: '编辑推荐',
    desc: '国产漫画精品力作一网打尽，从修真仙侠到都市传说，见证国漫的创作力量。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20with%20modern%20urban%20setting%20and%20stylish%20characters%2C%20trendy%20fashion%20aesthetic%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20minimal%20composition&width=400&height=280&seq=card-07&orientation=landscape',
    title: '韩漫精品推荐',
    tag: '专题推荐',
    desc: '当红韩国条漫精选，独特的叙事节奏和精致的画风，带你领略韩漫的独特魅力。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑团队精心策划的漫画推荐专题，帮你发现下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, i) => {
            const isAccent = i === 0 || i === 4 || i === 6;
            return (
              <a
                key={card.title}
                href="#cards"
                className={`group rounded-lg overflow-hidden cursor-pointer transition-colors ${
                  isAccent ? 'bg-accent-50 hover:bg-accent-100/80' : 'bg-background-50 hover:bg-background-200/40'
                }`}
              >
                <div className="relative w-full aspect-[4/3] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-secondary-500/90 text-background-50 text-xs font-medium rounded-full">
                    {card.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-950 mb-1.5 whitespace-nowrap">{card.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}